import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types';
import { Tabs, TabList, Tab, TabPanels, TabPanel, useTabsContext } from '@reach/tabs'
import { Menu, MenuList, MenuButton, MenuItem } from '@reach/menu-button';
import Icon from '../Icon'
import './style.scss'

const ModernTabContent = ({ children, className = '', ...props }) => {

    return (
        <TabPanel className={`modern-tabs__content ${className}`} {...props}>
            {children}
        </TabPanel>)
}

const MyMenu = ({ tabTitles, IconComponent, children }) => {
    const { selectedIndex } = useTabsContext();
    return (
        <Menu>
            <div className='modern-tabs__menu-container'>
                <MenuButton className="modern-tabs__menu-button">
                    {tabTitles[selectedIndex]}
                    <Icon>keyboard_arrow_down</Icon>
                </MenuButton>
                <IconComponent />
            </div>
            {children}
        </Menu>
    )
}

const MyMenuItem = ({ onChange, children }) => {
    return (<MenuItem className={`modern-tabs__menu-item`} onSelect={onChange} >
        {children}
    </MenuItem>)
}

const MyMenuList = ({ children }) => {
    return (
        <MenuList className='modern-tabs__menu-list'>{children}</MenuList>
    )
}

const ModernTabContainer = ({ children, tabTitles, IconComponent, className = '', ...props }) => {
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabsChange = (index) => {
        setTabIndex(index);
    };

    return (<Fragment>
        {/* Mobile section */}
        <div className={`modern-tabs modern-tabs--small ${className}`}>
            <Tabs as={MyMenu} tabTitles={tabTitles} IconComponent={IconComponent} index={tabIndex} onChange={handleTabsChange} {...props}>

                <TabList as={MyMenuList} >
                    {tabTitles.map((title, index) => <Tab aria-selected={index === tabIndex} data-selected={index === tabIndex} onChange={() => handleTabsChange(index)} as={MyMenuItem}>{title}</Tab>)}
                </TabList>
                <TabPanels>
                    {children}
                </TabPanels>
            </Tabs>
        </div>
        {/* Wider screen section */}
        <Tabs onChange={handleTabsChange} className={`modern-tabs modern-tabs--wide ${className}`} {...props}>

            <div className='modern-tabs__tab-container'>
                <TabList >
                    {tabTitles.map(title => <Tab>{title}</Tab>)}
                </TabList>
                <IconComponent />
            </div>
            <TabPanels>
                {children}
            </TabPanels>
        </Tabs>
    </Fragment>)
}


ModernTabContainer.propTypes = {
    titles: PropTypes.array.required,
    className: PropTypes.string,
    IconComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    children: PropTypes.node
};

export { ModernTabContainer, ModernTabContent }
